import { useEffect, useState } from "react";
import type { DashboardPayload } from "../types/dashboard";
import { apiGet } from "./api";

interface State {
  data: DashboardPayload | null;
  error: string | null;
  loading: boolean;
}

export function useDashboard(): State {
  const [state, setState] = useState<State>({
    data: null,
    error: null,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    apiGet<DashboardPayload>("/dashboard")
      .then((data) => {
        if (!cancelled) setState({ data, error: null, loading: false });
      })
      .catch((err: Error) => {
        if (!cancelled) setState({ data: null, error: err.message, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
